export const INTEGRATION_STATUS = {
  INACTIVE: { label: 'Inactive', value: 1 },
  ACTIVE: { label: 'Active', value: 2 }
};

export const INTEGRATION_TYPE = {
  UNKNOWN_TYPE: { label: 'UnknownType', value: 1 },
  GOMBA_SHOP: { label: 'GombaShop', value: 2 },
  OPENCART: { label: 'Opencart', value: 3 },
};

export const CATEGORY_SOURCE_TYPE = {
  UNKNOWN_CATEGORY: { label: 'UnknownCategory', value: 0 },
  SVILA: { label: 'Svila', value: 1 },
  GOMBA_SHOP: { label: 'GombaShop', value: 2 },
  OPENCART: { label: 'Opencart', value: 3 },
}